import { Spacing, useScopedSelector } from 'ia-react-core';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Content from '../../../components/_Content';
import { NewsResourceInfo } from '../../../components/NewsResource/NewsResource';
import { News } from '../../../interfaces/News';
import { StyledPagination, StyledTitle } from './Grid.styles';

export interface GridProps { }

const Grid: FC<GridProps> = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemPerPage = 12;
  const location = useLocation();
  const { t } = useTranslation('AllNewsPage');
  const news: News[] = useScopedSelector(NewsResourceInfo.dataDst);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setCurrentPage(Number(searchParams.get('page')) || 1);
  }, [location.search]);
  if (!news || news.length === 0) return null;

  return (
    <>
      <StyledTitle>
        {t('title')}
      </StyledTitle>
      <Content currentPage={currentPage} isAllNews news={news?.slice(currentPage * itemPerPage - itemPerPage, currentPage * itemPerPage)} />
      <Spacing m-t={20}>
        <StyledPagination currentPage={currentPage} data-testid="AllNewsPagePagination" onPageChange={setCurrentPage} itemCount={news.length} itemPerPage={itemPerPage} name="/App.features.news.pagination" />
      </Spacing>
    </>
  );
};

export default (Grid);
